import store from '../store';

let ws;
const httpConfig = require('../../httpConfig');

let url = '';
let lockReconnect = false; // 避免重复连接
// 心跳检测
const heartCheck = {
  timeout: 20000, // 20秒
  timeoutObj: null,
  serverTimeoutObj: null,
  reset() {
    clearTimeout(this.timeoutObj);
    clearTimeout(this.serverTimeoutObj);
    return this;
  },
  start() {
    const self = this;
    this.timeoutObj = setTimeout(() => {
      // 这里发送一个心跳，后端收到后，返回一个心跳消息，
      // onmessage拿到返回的心跳就说明连接正常
      ws.send('HeartBeat');
      self.serverTimeoutObj = setTimeout(() => { // 如果超过一定时间还没重置，说明后端主动断开了
        ws.close();// 如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
      }, self.timeout);
    }, this.timeout);
  },
};
function reconnect() {
  if (lockReconnect) return;
  lockReconnect = true;
  // 没连接上会一直重连，设置延迟避免请求过多
  setTimeout(() => {
    // eslint-disable-next-line no-use-before-define
    contentSocket();
    lockReconnect = false;
  }, 2000);
}
export default function contentSocket(roomId, userId) {
  if (roomId && userId) {
    url = `${process.env.VUE_APP_HOST_ENV === 'dev' ? httpConfig.ws : httpConfig.wsProd}/ws/liveRoom/${roomId}/${userId}`;
  }
  try {
    ws = new WebSocket(url);
    ws.onclose = () => {
      reconnect();
    };
    ws.onerror = () => {
      reconnect();
    };
    ws.onopen = () => {
      // 心跳检测重置
      console.log('socket open');
      heartCheck.reset().start();
    };
    ws.onmessage = (evt) => {
      heartCheck.reset().start();
      if (evt.data === 'pong') return;
      const data = JSON.parse(evt.data);
      if (data.code === '10000') {
        console.log('socket message success', data.data);
        const { messageType } = data.data;
        switch (messageType) {
          case 10:
            // 这里是接收在线人数
            store.dispatch('liveOnlineNum', data.data.content);
            break;
          case 20:
            // 这里是接收文本消息
            store.dispatch('socketMsg', data.data);
            break;
          case 25:
            // 这里是接受进入直播间消息
            store.dispatch('socketMsg', data.data);
            break;
          case 30:
            // 这里是接收图片消息
            store.dispatch('socketMsg', data.data);
            break;
          case 40:
            // 这里这里是事件
            store.dispatch('socketMsg', data.data);
            break;
          default:
            break;
        }
      }
    };
  } catch (e) {
    reconnect();
  }
}
